import React from 'react';
import { SimulationConfig } from './types';
import { AudioVolumeSection } from './AudioVolumeSection';
import { AudioWorkshopTab } from './AudioWorkshopTab';
import { AudioPostProcessingSection } from './AudioPostProcessingSection';
import { CustomSoundUploadSection } from './CustomSoundUploadSection';
import { SongConverterSection } from './SongConverterSection';
import { MelodyLibrarySection } from './MelodyLibrarySection';

interface AudioStudioTabProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
  onFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isAnalyzing: boolean;
  analysisProgress: number;
  onBallSoundUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isUploadingBallSound: boolean;
  cloudSaves?: any[];
}

export const AudioStudioTab: React.FC<AudioStudioTabProps> = ({ 
  config, setConfig, onFileUpload, isAnalyzing, analysisProgress, onBallSoundUpload, isUploadingBallSound,
  cloudSaves = []
}) => (
  <div className="flex flex-col gap-4 w-full">
    <AudioVolumeSection config={config} setConfig={setConfig} />
    <AudioWorkshopTab config={config} setConfig={setConfig} />
    <AudioPostProcessingSection config={config} setConfig={setConfig} cloudSaves={cloudSaves} />
    <CustomSoundUploadSection config={config} onBallSoundUpload={onBallSoundUpload} isUploadingBallSound={isUploadingBallSound} />
    <SongConverterSection config={config} onFileUpload={onFileUpload} isAnalyzing={isAnalyzing} analysisProgress={analysisProgress} />
    <MelodyLibrarySection config={config} setConfig={setConfig} />
  </div>
);
